<template>
    <div class="inner-enter-guiding">
        <div class="content">
            <div class="advantage">
                <div class="advantage-item">
                    <i class="icon icon-32 icon-flow-01">
                    </i>
                    <span class="advantage-name">保护版权</span>
                    <span class="advantage-desc">发现盗版或侵权行为立即处理绝不姑息</span>
                </div>
                <div class="advantage-item">
                    <i class="icon icon-32 icon-flow-02">
                    </i>
                    <span class="advantage-name">流量资源</span>
                    <span class="advantage-desc">喜马拉雅FM拥有3.3亿用户日均使用时长126钟，为内行业之最</span>
                </div>
                <div class="advantage-item">
                    <i class="icon icon-32 icon-flow-03">
                    </i>
                    <span class="advantage-name">数据分析</span>
                    <span class="advantage-desc">提供丰富的分析数据来为您的运营策略提供有力的支撑</span>
                </div>
                <div class="advantage-item">
                    <i class="icon icon-32 icon-flow-04">
                    </i>
                    <span class="advantage-name">持续受益</span>
                    <span class="advantage-desc">持续享受流量红利带来的收益分成</span>
                </div>
            </div>
            <span class="slogan">入驻流程</span>
            <div class="flow">
                <div class="flow-item">
                    <img :src="`${IMG_HOST}pic-commit-info@2x.png`">
                    <span>提交资料</span>
                </div>
                <div class="flow-line"></div>
                <div class="flow-item">
                    <img :src="`${IMG_HOST}pic-auth@2x.png`">
                    <span>审核</span>
                </div>
                <div class="flow-line"></div>
                <div class="flow-item">
                    <img :src="`${IMG_HOST}pic-sign@2x.png`">
                    <span>签约</span>
                </div>
            </div>
            <div class="buttons">
                <el-button type="primary" @click.native="apply">立即申请</el-button>
            </div>
        </div>
    </div>
</template>
<script>
  import axios from 'axios';
  export default {
    components: {

    },
    data() {
      return {

      }
    },
    computed: {
      IMG_HOST(){
        return this.$store.state.IMG_HOST;
      }
    },
    methods: {
      apply () {
        this.$router.push({ name: 'copyrighterApply'})
      }
    }
  }

</script>
<style lang="sass">
    @import "../../../sass/copyright/enterGuiding.scss";
    @import "../../../sass/icons.scss";
</style>


// WEBPACK FOOTER //
// InnerEnterGuiding.vue?2077f986